import { memo } from 'react';
import styles from './SortingBtn.module.scss';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
interface SortingBtnProps {
  handleSort: () => void;
  selected: boolean;
  text: string;
}
const SortingBtn = ({
  handleSort,
  selected,
  text
}: SortingBtnProps) => {
  return <Box className={styles['sorting-btn-container'] + ' ' + `${selected ? styles['selected'] : ''}`} onClick={() => handleSort()} data-sentry-element="Box" data-sentry-component="SortingBtn" data-sentry-source-file="SortingBtn.tsx">
      <Typography variant="bodyM_Bold" className={styles['sorting-button-text']} data-sentry-element="Typography" data-sentry-source-file="SortingBtn.tsx">
        {text}
      </Typography>
    </Box>;
};
export default memo(SortingBtn);